import { render, staticRenderFns } from "./simplifyContractFee.vue?vue&type=template&id=55651cd8&scoped=true"
import script from "./simplifyContractFee.vue?vue&type=script&lang=js"
export * from "./simplifyContractFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyContractFee.vue?vue&type=style&index=0&id=55651cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55651cd8",
  null
  
)

export default component.exports